import { createSlice } from '@reduxjs/toolkit';

import { STATUS } from '../../../config/constants';

const initialState = {
  status: STATUS.NONE,
};

export const sendActivitiesSplitedSlice = createSlice({
  name: 'sendActivitiesSplited',
  initialState,
  reducers: {
    resetState: (state) => {
      state.status = STATUS.NONE;
    },
    request: (state) => {
      state.status = STATUS.FETCHING;
    },
    success: (state) => {
      state.status = STATUS.SUCCESS;
    },
    failure: (state, action) => {
      const { payload: error } = action;
      state.status = STATUS.FAILURE;
      state.error = error;
    },
    readyForNextState: (state) => {
      state.status = STATUS.NONE;
      state.error = undefined;
    },
  },
});

export const { resetState, request, success, failure, readyForNextState } =
  sendActivitiesSplitedSlice.actions;

export const status = (state) => state.sendActivitiesSplited.status;

export const error = (state) => state.sendActivitiesSplited.error;

export default sendActivitiesSplitedSlice.reducer;
